import React, { useState, useEffect } from "react";
import { Card, Table, Select, Button, Modal, Space, Spin, message } from "antd";
import { DownloadOutlined } from "@mui/icons-material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

import { getOnboardingByApplicant } from "Services/AdminServices/OnBoardingService";
import generateOnboardingPDF from "FileGenerator/AdminFileGenerator/OnboardingReport";

const { Option } = Select;

function ReceivedDocuments() {
  const [departments, setDepartments] = useState([]);
  const [selectedDept, setSelectedDept] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [docLoading, setDocLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    fetchDepartments();
    fetchEmployees(null, true);
  }, []);

  const fetchDepartments = async () => {
    try {
      const res = await axiosInstance.get(API.department.getList);
      setDepartments(res.data);
    } catch (err) {
      console.error(err);
      message.error("Failed to load departments");
    }
  };

  const fetchEmployees = async (departmentId = null, hasDocuments = true) => {
    setLoading(true);
    try {
      const res = await axiosInstance.get(API.employee.getAll(departmentId, hasDocuments));
      setEmployees(res.data);
      console.log("alle empl", res.data);
    } catch (err) {
      console.error(err);
      message.error("Failed to load employees");
    } finally {
      setLoading(false);
    }
  };

  // ---------------- DOCUMENTS ----------------
  const handleViewDocuments = async (employeeId) => {
    setDocLoading(true);
    try {
      const res = await axiosInstance.get(API.hiringContracts.getByUserId(employeeId));

      const data = res.data;

      const documentList = [
        { name: "NDA File", file: data.ndafile },
        { name: "NCA File", file: data.ncafile },
        { name: "Employee Agreement", file: data.employeeAgreement },
        { name: "I-9 Form", file: data.i_nine },
        { name: "W-4 Form", file: data.w_four },
        { name: "Offer Letter", file: data.offerLetter },
        { name: "HR Policy", file: data.hrPolicy },
        { name: "Resume", file: data.resume },
      ].filter((doc) => doc.file);

      setDocuments(documentList);
      setIsModalOpen(true);
    } catch (err) {
      console.error(err);
      message.error("Failed to load documents");
    } finally {
      setDocLoading(false);
    }
  };

  // ---------------- PDF REPORT ----------------
  const handleDownloadOnboardingReport = async (jobApplicantId, name, email) => {
    try {
      const res = await getOnboardingByApplicant(jobApplicantId);
      console.log("job applicant id ", jobApplicantId);
      console.log("res of onbaording", res);

      if (!res?.exists || !res?.data) {
        message.warning("No onboarding data found");
        return;
      }

      generateOnboardingPDF(res, { name, email });
    } catch (error) {
      console.error(error);
      message.error("Failed to download onboarding report");
    }
  };

  const employeeColumns = [
    {
      title: "Employee Name",
      dataIndex: "firstName",
      key: "firstName",
      render: (_, record) => `${record.firstName} ${record.lastName}`,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space>
          <Button className="btn-primary" onClick={() => handleViewDocuments(record.id)}>
            View Documents
          </Button>

          <Button
            icon={<DownloadOutlined />}
            onClick={() =>
              handleDownloadOnboardingReport(
                record.jobApplicantId,
                `${record.firstName} ${record.lastName}`,
                record.email
              )
            }
          >
            Onboarding Report
          </Button>
        </Space>
      ),
    },
  ];

  const documentColumns = [
    {
      title: "Document Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button type="link">View</Button>
          <Button type="link" icon={<DownloadOutlined />}>
            Download
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="body flex-grow-1 px-3">
        <Card title="Employee Received Documents">
          {/* Department Filter */}
          <div style={{ marginBottom: 20 }}>
            <label style={{ marginRight: 10 }}>Select Department:</label>

            <Select
              style={{ width: 300 }}
              placeholder="Choose Department"
              onChange={(value) => {
                setSelectedDept(value);
                fetchEmployees(value, true);
              }}
              value={selectedDept}
            >
              {departments.map((dept) => (
                <Option key={dept.id} value={dept.id}>
                  {dept.departmentName}
                </Option>
              ))}
            </Select>
          </div>

          {/* Employee Table */}
          {loading ? (
            <Spin />
          ) : (
            <Table
              dataSource={employees}
              columns={employeeColumns}
              rowKey="id"
              pagination={false}
            />
          )}
        </Card>

        {/* Documents Modal */}
        <Modal
          title="Employee Documents"
          open={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          footer={null}
          width={700}
        >
          {docLoading ? (
            <Spin />
          ) : (
            <Table
              dataSource={documents}
              columns={documentColumns}
              rowKey="name"
              pagination={false}
            />
          )}
        </Modal>
      </div>
    </DashboardLayout>
  );
}

export default ReceivedDocuments;
